import * as React from 'react';
import Accordion, { AccordionProps } from '@material-ui/core/Accordion';

import AccordionSummary, { AccordionSummaryProps } from '@material-ui/core/AccordionSummary';

import AccordionDetails, { AccordionDetailsProps } from '@material-ui/core/AccordionDetails';

import { withStyles } from '@material-ui/core';

export type DSAccordionProps = AccordionProps;

export const DSAccordion: React.FC<DSAccordionProps> = props => <Accordion {...props} />;

export type DSAccordionSummaryProps = AccordionSummaryProps;

export const DSAccordionSummary: React.FC<DSAccordionSummaryProps> = props => <AccordionSummary {...props} />;

export type DSAccordionDetailsProps = AccordionDetailsProps;

export const DSAccordionDetails: React.FC<DSAccordionDetailsProps> = props => <AccordionDetails {...props} />;

export const DSAccordionInline: typeof DSAccordion = withStyles({
    expanded: {
        margin: '0 !important',
    },
    root: {
        '&:before': {
            display: 'none',
        },
        background: 'none',
        boxShadow: 'none',
    },
})(DSAccordion) as typeof DSAccordion;

export const DSAccordionSummaryInline: typeof DSAccordionSummary = withStyles({
    root: {
        '&:hover': {
            'background-color': 'rgba(255, 255, 255, 0.03)',
        },
        '&> *': {
            margin: '6px 0px !important',
        },
        'justify-content': 'start',
        'min-height': '0 !important',
        padding: '0px 5px',
    },
})(DSAccordionSummary) as typeof DSAccordionSummary;

export const DSAccordionDetailsInline: typeof DSAccordionDetails = withStyles({
    root: {
        padding: 0,
    },
})(DSAccordionDetails) as typeof DSAccordionDetails;
